
import Vue from 'vue'
export default Vue.extend({
  name: 'AheduFooter',
  props: {
    showLink: { type: Boolean, default: false },
  },
  data() {
    return {
      icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAB8lBMVEUAAAD3xIzE4trG48VQHf/0ujrt3HrwrjeHXVvlmkKfaVn/9ab/xZrkt2ncuXTq9ZHUp2HxZyPHpGjmt163rXnvxl7yzFXorkXz3G3srD3sp0jmpE3opEDrr0/wx2PxzWrnpViykHmwjnWzo3TsuGCronnZlTTuxWP/y2PuxnLvqUzqv2juz3j223zzxWj12HDWsXz35or/0HTWr3PZjEH/6nz/y1r/wFnnvXXdwZrjwZf/54fqpVr/4Xjf///jAADxvzlBVJEoJYEvKXx3cXbtzV3yzFL5z0/ywkz1xkf6wUbyv0Txuz/xtDbroy/kkC77ti3ujSb+oBvrThbpZhHyJQDsAADnAADfAAAlKpIvQJE5QoIgIYKWnIGWl38cHXo8R3gXAHYnLXTUuXG8nG0rF2l/amgaAGeZimXBp2Scg2MyGWNsV2Hnvl6ZeV2zjlh/XljisFbtzVP0xlOVbFJ/WlJTAlH3x1A9AE2ndUzy0Ei0e0TqpELzwkH6lEDtrz+KVj/7sj3llTy6dDv6xTqTIDnspTf/yjWrZTPxsDH0oy7mky7/symCACetWyXlcSPwlCKsACLzeyHnbSDmURv7rRrrYRmfABjnURLdMxL4aQ/9iAzTJAL2RQH/VgDYQAD/NgDkNAD6HgDnGQD3FADZAAARUQ8gAAAAP3RSTlMADwgEAv0X/e7q2hgYFxYL/v729vXt7erj4+Lg0s/JyMfGxsK8ura0srCup5mIhYJ9end2cWtjYWBbW1UlERCnfDb7AAAA/klEQVQY02MAAWYeKyVFSx4mBhgw5uroq87nMoByWcxKGxaGzhXMKLCG8PU4cmaF2S+2r3PhMAIJ2Co7VS6yD7ePCE1xVuUHKjAXimleYj9jWniYQLyIKTMDk1ZhZN7sOf2Bk4OynHI1+Bl4ORsdU0OCZ04JnpTt6CXFBxQIiktcumB+yLyI9NgeaT4GRoUA16iK3ukTW8ucXb1UGBnYhJu6kl0S0kqSojOn+omyMTDpsPsHtle1BBS5Tehm1WdmYLBTd/Bv82T1dmevKdYGeYdb3t3Dx8fD26/erVyOGyjAqCvmUOvL2unr4ClhyAj2vI2JmoykuKymBRsLAwMA0n0+v/r6aYEAAAAASUVORK5CYII=',
      links: [
        { title: '中华人民共和国教育部', href: 'http://www.moe.gov.cn/' },
        { title: '国家中小学智慧教育', href: 'https://basic.smartedu.cn/' },
        { title: '安徽省教育厅', href: 'http://jyt.ah.gov.cn/' },
        { title: '安徽智慧教育平台', href: 'http://www.ah.smartedu.cn/' },
        { title: '安徽招生考试网', href: 'https://www.ahzsks.cn/index.htm' },
      ],
      beian: {
        gongwang: {},
        icp: {},
      } as any,
    }
  },
  mounted() {
    this.beian = window.beian
  },
})
